// Filipino (Tagalog) Translation
export default {
  // Navigation
  navHome: 'Home',
  navMethod: 'TSMC Method',
  navServices: 'Mga Serbisyo',
  navAbout: 'Tungkol sa Amin',
  navFaq: 'FAQ',
  navContact: 'Makipag-ugnayan at Mag-book',
  navBlog: 'BLOG',
  
  // Buttons
  bookNow: 'Mag-book Ngayon',
  lineConsult: 'LINE Consultation',
  bookNowFull: 'Mag-book Ngayon',
  
  // Hero
  heroTitle1: 'Katumpakan ng Engineer',
  heroTitle2: 'Ibalik ang Istruktura ng Katawan',
  heroSubtitle: 'Tainan Jiali Propesyonal na Chiropractic at Sports Massage',
  heroDesc: 'Pinagsasama ang Nangungunang Teknika mula sa USA, Japan, Australia, Canada | Malalim na Fascia Release | Structural Mechanics',
  heroCert: 'Multi-National Certified',
  heroPrice: 'Transparent na Presyo',
  heroTime: 'Bukas Sabado-Miyerkules',
  
  // What is Chiropractic
  whatIsTitle: 'Ano ang',
  whatIsChiro: 'Chiropractic',
  whatIsSubtitle: "Chiropractic schools and manual traditions",
  whatIsPara1: "In some international systems, ",
  whatIsChiroFull: "Chiropractic",
  whatIsPara1b: " is a manual tradition that originated in the United States and was founded by ",
  whatIsFounder: 'Daniel David Palmer',
  whatIsPara1c: " in 1895. The following describes that school’s perspective.",
  whatIsPara2: "Within that tradition, specific manual methods are used to consider joint movement and whole-body use, ",
  whatIsRestore: "with adjustments guided by personal comfort",
  whatIsPara2b: "; this is not a disease diagnosis, medical treatment, or guarantee of a specific result.",
  whatIsBoxTitle: "Understanding daily body use as a whole",
  whatIsBoxDesc: "This approach considers daily loading, movement habits, and how different areas work together:",
  whatIsCycle1: "Repeated demands from work or exercise",
  whatIsCycle2: "Muscle tension and movement habits can influence each other",
  whatIsCycle3: "Different areas coordinate and compensate during movement",
  whatIsCycle4: "Look at everyday body use from a whole-body perspective",
  chiroCardTitle: 'Chiropractic',
  chiroCardDesc: 'Dalubhasa sa',
  chiroCardFocus: 'pag-aayos ng buto',
  chiroCardDesc2: ', ibinabalik ang normal na mobility ng kasukasuan sa pamamagitan ng tumpak na mga teknika',
  massageCardTitle: 'Sports Massage',
  massageCardDesc: 'Dalubhasa sa',
  massageCardFocus: 'pagpapahinga ng kalamnan',
  massageCardDesc2: ', nagpapalabas ng malalim na tensyon ng fascia at pinagbubuti ang di-balanseng kalamnan',
  whatIsSummary: 'Pinagsasama ng TSMC ang dalawang pamamaraan',
  whatIsSummary2: ', kinikilala kung aling sistema ang sanhi ng problema at naglalapat ng angkop na mga teknika, sinusuri ang pangkalahatang "sanhi" at "pag-iwas" batay sa mechanics at istruktura',
  
  // TSMC Method
  methodTitle: 'TSMC',
  methodTitleSuffix: 'Method',
  methodSubtitle: 'Natatanging Sistema ng Pag-aayos ng Istruktura ng Katawan ng TSMC',
  methodT: 'Technology',
  methodTSub: 'Pagsasama ng Multi-National na Teknika',
  methodTDesc: 'Pinagsasama ang nangungunang chiropractic techniques mula sa USA, Japan, Australia, Canada para sa komprehensibong pag-aalaga',
  methodS: 'Stretching',
  methodSSub: 'Stretching at Structural Adjustment',
  methodSDesc: 'Sistematikong pinagbubuti ang kawalan ng balanse sa istruktura ng katawan mula sa gulugod, pelvis hanggang sa mga kasukasuan ng mga kasukasuan',
  methodM: 'Mobility',
  methodMSub: 'Optimization ng Mobility',
  methodMDesc: 'Target sa malalim na kalamnan at fascia upang pahusayin ang range of motion at flexibility ng kasukasuan',
  methodC: 'Chiro',
  methodCSub: 'Customized Chiropractic',
  methodCDesc: 'Pagdidisenyo ng personalized care plans batay sa indibidwal na katawan, sintomas, at lifestyle',
  methodSystemTitle: 'Ang Katawan ay Isang Tumpak na Biomechanical System',
  methodSystem1: 'Ang mga buto ay kumokonekta sa mga kalamnan, ang mga kalamnan ay humihinila ng mga buto',
  methodSystem2: 'Ang mga kalamnan ay naglalabas ng puwersa, sumusuporta sa mga buto, ang mga buto ay sumusuporta sa buong katawan',
  methodSystem3: 'Lumalaban sa gravity at tumutugon sa iba\'t ibang puwersa sa buhay',
  
  // Services
  services: 'Mga Propesyonal na Serbisyo',
  servicesDesc: 'Dual-Track Care - Chiropractic + Sports Massage',
  chiro: 'Chiropractic',
  chiroService: "Specific manual methods · Daily movement care · Body awareness",
  chiroFeature1: "Manual methods adjusted to personal comfort",
  chiroFeature2: "Consider everyday movement and body-use habits",
  chiroFeature3: "Daily care for seated, standing, and physical-work lifestyles",
  chiroPrice: '$1000',
  chiroPriceSuffix: 'pataas / 30-40 min',
  massage: 'Chiropractic + Sports Massage',
  massageService: "Manual care · Deep fascial relaxation · Post-exercise care",
  massageFeature1: "Deep muscle and fascial relaxation based on personal needs",
  massageFeature2: "Post-exercise relaxation for regularly active people",
  massageFeature3: "Whole-body relaxation for office and physical workers",
  massagePrice: '$2300',
  massagePriceSuffix: '/ 90 minuto',
  suitable: 'Angkop para sa:',
  chiroSuitable: "office workers, standing workers, physical workers, and people who value daily body care",
  massageSuitable: "active people, office workers, physical workers, and those seeking post-exercise relaxation",
  

  // Who Needs Our Services
  whoNeedsTitle: "Anong lifestyle ang angkop sa araw-araw na body care?",
  whoNeedsSubtitle: "Nakaayos ayon sa lifestyle at gamit ng katawan—hindi ayon sa sakit o paggamot",
  
  // Target Groups
  targetOffice: "Desk at Office Group",
  targetOfficeSymptom1: "Mahabang oras sa computer",
  targetOfficeSymptom2: "Kaunting galaw sa araw-araw",
  targetOfficeSymptom3: "Matagal sa iisang posisyon",
  targetOfficeSymptom4: "Nais ng araw-araw na relaxation para sa leeg, balikat at likod",
  
  targetAthlete: "Regular na Aktibong Group",
  targetAthleteSymptom1: "Strength training o ball sports",
  targetAthleteSymptom2: "Nais mag-relax pagkatapos mag-ehersisyo",
  targetAthleteSymptom3: "Mahalaga ang stretching at regular na care",
  targetAthleteSymptom4: "Nais maunawaan ang galaw ng katawan",
  
  targetPosture: "Standing Work Group",
  targetPostureSymptom1: "Trabahong matagal nakatayo",
  targetPostureSymptom2: "Madalas maglakad o manatili sa isang posisyon",
  targetPostureSymptom3: "Madalas gamitin ang mga binti",
  targetPostureSymptom4: "Nais ng leg at whole-body relaxation",
  
  targetChronic: "Physical Work Group",
  targetChronicSymptom1: "Madalas magbuhat sa trabaho",
  targetChronicSymptom2: "Paulit-ulit na galaw",
  targetChronicSymptom3: "Mataas ang pisikal na gawain",
  targetChronicSymptom4: "Nais ng whole-body muscle relaxation",
  
  targetSenior: "Mga Commuter at Driver",
  targetSeniorSymptom1: "Mahabang oras ng pagmamaneho o pagsakay araw-araw",
  targetSeniorSymptom2: "Madalas na mahabang biyahe o pag-commute",
  targetSeniorSymptom3: "Trabahong kailangang manatili sa posisyon sa pagmamaneho",
  targetSeniorSymptom4: "Nais ng whole-body relaxation sa oras ng pahinga",
  
  targetPregnant: "Regular Body-Care Group",
  targetPregnantSymptom1: "Walang partikular na pangangailangang medikal",
  targetPregnantSymptom2: "Pinahahalagahan ang relaxation at self-care",
  targetPregnantSymptom3: "Nais maunawaan ang araw-araw na galaw",
  targetPregnantSymptom4: "Regular na body-care session",
  
  // About Us
  aboutTitle: 'Mula Engineer Tungo sa Bodyworker',
  aboutSubtitle: 'Pilosopiya at Pamamaraan',
  aboutPara1: 'Ang pag-iisip ng engineer ay',
  aboutPara1Highlight: '"paglutas ng problema sa ugat"',
  aboutPara1b: '. Tulad ng pag-debug ng code, hindi lang namin ginagamot ang sintomas ng sakit, hinahanap namin ang ugat ng structural imbalances.',
  aboutPara2: 'Bawat adjustment ay parang pag-recompile ng structural code ng katawan. Pinagsasama namin ang nangungunang mga teknika mula sa',
  aboutPara2Highlight: 'USA, Japan, Australia, at Canada',
  aboutPara2b: ', gamit ang engineer-level na precision para magbigay ng pinakamalalim na optimization para sa iyong katawan.',
  aboutPara3: 'Sa Tainan Jiali, nag-aalok kami ng higit pa sa tradisyonal na massage. Nagbibigay kami ng',
  aboutPara3Highlight: 'sistematikong pangangalaga sa katawan',
  aboutPara3b: ' na pinagsasama ang modernong anatomy, biomechanics, at sports science.',
  aboutQuote: 'Ang katawan ay isang precision biomechanical system. Ang kailangan nito ay hindi pansamantalang pag-aayos, kundi sistematikong structural reconstruction. Ginagamit namin ang engineering logic na pinagsama sa propesyonal na mga teknika upang tulungan ang bawat kliyente na maibalik ang optimal na kondisyon ng katawan.',
  aboutQuoteAuthor: '— TSMC Founder',
  
  // FAQ Q&A
  faq1Q: 'Ano ang pagkakaiba ng Chiropractic at tradisyonal na massage?',
  faq1A: 'Ang Chiropractic ay nakatuon sa "skeletal joint alignment", ibinabalik ang normal na joint mobility sa pamamagitan ng tumpak na mga teknika upang sa batayan ay mapabuti ang body mechanics. Ang tradisyonal na massage ay nakatuon sa meridian clearing at muscle relaxation. Pinagsasama ng TSMC ang pareho para sa komprehensibong pag-aalaga.',
  
  faq2Q: 'Masakit ba? Ligtas ba?',
  faq2A: 'Ang aming mga teknika ay propesyonal na sinanay. Maaari kang makaramdam ng banayad na stretching o pressure, ngunit walang sakit. Lahat ng operasyon ay nasa ligtas na hangganan at inaayon ayon sa iyong kondisyon.',
  
  faq3Q: 'Gaano kadalas ako dapat pumunta?',
  faq3A: 'Nakadepende sa indibidwal na kondisyon. Para sa acute cases, inirerekomenda ang 1-2 beses bawat linggo. Para sa mga chronic na isyu, maaaring kailangan ng mas madalas na sessions sa simula (minsan bawat linggo), pagkatapos ay maaaring palawigin sa minsan bawat 2-4 na linggo para sa maintenance. Nagbibigay kami ng propesyonal na payo batay sa iyong sitwasyon.',
  
  faq4Q: 'Ano ang dapat kong dalhin sa unang pagbisita?',
  faq4A: 'Magsuot ng maluwag at komportableng damit. Kung nagkaroon ka ng body examinations (X-rays, MRI, atbp.), maaari mong dalhin ang mga ito para sa reference. Magsasagawa kami ng detalyadong body assessment bago gumawa ng personalized care plan.',
  
  faq5Q: 'Paano kayo nagsisikap?',
  faq5A: 'Ang Chiropractic ay nagsisimula sa $1000 (30-40 minuto), Chiropractic + Sports Massage $2300 (90 minuto). Ang presyo ay transparent walang nakatagong bayad. Para sa mga first-timers, inirerekomenda namin na magsimula sa Chiropractic upang masuri namin ang iyong kondisyon at magmungkahi ng angkop na mga serbisyo.',
  
  faq6Q: 'Maaari ba akong pumunta mula sa labas ng Tainan Jiali?',
  faq6A: 'Siyempre! Nagsisilbi kami sa mga kliyente mula sa lahat ng mga lugar ng Tainan, kabilang ang Jiali, Madou, Xuejia, Jiangjun, Qigu, Xigang, Anding, atbp. Convenient na transportasyon gamit ang Google Maps navigation.',

  // FAQ
  faqTitle: 'Mga Madalas Itanong',
  faqSubtitle: 'Tungkol sa Tainan Jiali Chiropractic at Massage',
  
  // Reviews
  reviewsTitle: 'Tunay na Feedback ng Customer',
  reviewsSubtitle: 'Mula sa Aming Pinahahalagahang Customers na may 5-Star Reviews',
  reviewsDisclaimer: 'Ang TSMC ay hindi institusyong medikal. Ang mga sipi sa ibaba mula sa Google customer reviews ay personal na karanasan lamang ng mga reviewer at hindi pahayag o garantiya ng TSMC tungkol sa medikal o resulta ng serbisyo.',
  reviewsViewAll: 'Tingnan ang Lahat ng Google Reviews',
  reviewsFrom: 'Pinagmulan',
  
  // Training
  trainingTitle: 'International Training',
  trainingSubtitle: 'Patuloy na Propesyonal na Pag-unlad',
  trainingIntro: 'Sa nakaraang mga taon, patuloy na nag-aaral mula sa mga propesyonal na instructor sa buong mundo, patuloy na pinagbubuti ang teknikal na kadalubhasaan at dala-dala ang mga advanced na konsepto ng chiropractic pabalik sa Taiwan.',
  trainingYear: '',
  trainingStats1: 'Patuloy na Pag-aaral',
  trainingStats1Val: '10+ Taon',
  trainingStats2: 'International Instructors',
  trainingStats2Val: '10+ Masters',
  trainingStats3: 'Cross-border Training',
  trainingStats3Val: 'Maraming Beses',
  
  // CTA
  ctaTitle: "Handa ka na bang maglaan ng oras sa body care?",
  ctaDesc: "Pumili ng non-medical bodywork ayon sa lifestyle at relaxation needs",
  ctaBooking: 'Mag-book Online',
  ctaLine: 'LINE Online Consultation',
  ctaTransparent: 'Transparent na Presyo',
  ctaTransparentDesc: 'Walang Nakatagong Bayad\nMalinaw na Presyo',
  ctaCert: 'Propesyonal na Sertipikado',
  ctaCertDesc: 'Multi-National\nMga Teknika',
  ctaFlex: 'Flexible na Booking',
  ctaFlexDesc: 'Online System\nMabilis at Madali',
  
  // Footer
  footerHours: 'Oras ng Operasyon',
  footerHoursDays: 'Sabado hanggang Miyerkules',
  footerHoursTime: '11:00 AM - 9:40 PM',
  footerHoursClosed: 'Sarado Huwebes at Biyernes',
  footerLocation: 'Lokasyon',
  footerLocationCity: 'Jiali District, Tainan City',
  footerLocationAddr: 'No. 130-95, Anxi, Wenxin Village',
  footerLocationMap: 'Google Maps Navigation',
  footerLocationSearch: 'Buksan ang TSMC Chiro Studio direkta sa Google Maps',
  footerLocationGuide: 'Hindi na kailangang hanapin ang address. Pindutin ang button sa ibaba para sa direktang navigation.',
  footerLocationOpenMap: 'Buksan ang Direktang Google Maps Navigation',
  footerContact: 'Makipag-ugnayan',
  footerContactLine: 'Official LINE Account',
  footerFollow: 'Sundin Kami',
  footerServices: 'Mga Serbisyo',
  footerService1: 'Chiropractic',
  footerService2: 'Pagpapabuti ng Joint Mobility',
  footerService3: 'Sports Massage',
  footerService4: 'Malalim na Fascia Release',
  footerService5: 'Pag-aayos ng Pelvis',
  footerService6: 'Assessment at Optimization ng Postura',
  footerDisclaimer: 'Mahalagang Paalala:',
  footerDisclaimerText: "Ang TSMC ay nagbibigay ng non-medical traditional bodywork at sports massage para sa relaxation, body care, at body awareness. Hindi kami nagdi-diagnose o gumagamot ng sakit at hindi nagbibigay ng rehabilitation. Kung may tuloy-tuloy na pananakit, pamamanhid, panghihina, pagkahilo, o acute injury, kumonsulta muna sa lisensiyadong doktor.",
  footerBookingBtn: '🎯 Mag-book Online Ngayon',
  footerCopyright: '© 2026 TSMC - Tainan Jiali Professional Chiropractic & Sports Massage Studio',
  footerTagline1: 'Technology of Stretching & Mobility Chiro',
  footerTagline2: 'Tainan Jiali · Professional Chiropractic & Sports Massage',

  
  // Service Flow
  serviceFlowTitle: 'Ang Aming Proseso ng Serbisyo',
  serviceFlowSubtitle: 'Mula sa propesyonal na pagsusuri hanggang sa tumpak na adjustment, bawat hakbang ay nagsisiguro ng iyong kalusugan',
  serviceFlowPhase1: 'Yugto ng Pagsusuri',
  serviceFlowPhase2: 'Yugto ng Adjustment',
  serviceFlowScrollHint: 'Mag-scroll para makita ang buong proseso',
  step1Title: 'Indibidwal na Pagmamasid sa Galaw',
  step1Desc: 'Inoobserbahan ang piling galaw ayon sa ginhawa ng bawat tao upang maunawaan ang pang-araw-araw na aktibidad at paggamit ng katawan',
  step2Title: 'Pagsusuri ng Haba ng Binti',
  step2Desc: 'Tumpak na pagsukat ng pagkakaiba ng haba ng pelvis at ibabang binti upang matukoy ang structural imbalance',
  step3Title: 'Pagsusuri ng Paa',
  step3Desc: 'Suriin ang plantar pressure distribution at arko ng paa upang suriin ang gait problems',
  step4Title: 'Pressure Testing',
  step4Desc: 'Suriin ang muscle tension at joint mobility upang kumpirmahin ang problema',
  step5Title: 'Adjustment ng Likod',
  step5Desc: 'Malalim na myofascial release upang mapabuti ang hindi balanseng tensyon ng likod',
  step6Title: 'Adjustment ng Leeg at Balikat',
  step6Desc: 'Tumpak na adjustment para sa paninigas ng leeg at balikat upang maibalik ang mobility',
  step7Title: 'Kumpletong Pagsusuri',
  step7Desc: 'Muling pagsusuri pagkatapos ng session upang kumpirmahin ang pagbuti at magbigay ng susunod na rekomendasyon',
  servicesSummary1: "Two-track bodywork: manual care + massage",
  servicesSummary2: ", tailored to lifestyle and everyday relaxation needs",
};
